import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Presentation from '../views/Presentation.vue';
import Realisations from '../views/Realisations.vue';
import Contact from '../views/Contact.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/presentation',
    name: 'presentation',
    component: Presentation,
  },
  {
    path: '/realisations',
    name: 'realisations',
    component: Realisations,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
